import { UserRoles } from "../../shared/constants/common.constant";

export const TEAM_ROLE_GUIDS: Record<string, Record<string, string>> = {
  Default: {
    [UserRoles.Admin]: "290b3b43-bd4d-4c34-89e7-84810986882c",
    [UserRoles.Manager]: "3a1c4d52-ce5e-5d45-9af8-95921097993d",
    [UserRoles.Analyst]: "5c3e6f74-eg7g-7f67-bc1a-b7b43219bb5f",
    [UserRoles.Viewer]: "6d4f7g85-fh8h-8g78-cd2b-c8c5432acc6g",
  },
  "Team Name": {
    [UserRoles.Admin]: "7e5g8h96-gi9i-9h89-de3c-d9d6543bdd7h",
    [UserRoles.Manager]: "8f6h9ia7-hj0j-0i9a-ef4d-eae7654cee8i",
    [UserRoles.Analyst]: "ah8j1kc9-jl2l-2k1c-gh6f-gcg9876eggak",
    [UserRoles.Viewer]: "bi9k2lda-km3m-3l2d-hi7g-hdh0987fhhbl",
  },
  "Team Name 2": {
    [UserRoles.Admin]: "cj0l3meb-ln4n-4m3e-ij8h-iei1098giicm",
    [UserRoles.Manager]: "dk1m4nfc-mo5o-5n4f-jk9i-jfj2109hjjdn",
    [UserRoles.Analyst]: "fm3o6phe-oq7q-7p6h-lm1k-lhl4321jllep",
    [UserRoles.Viewer]: "gn4p7qif-pr8r-8q7i-mn2l-mim5432kmmfq",
  },
};

export const getTeamId = (teamName: string, roleName: string): string => {
  return (
    TEAM_ROLE_GUIDS[teamName]?.[roleName] ??
    "00000000-0000-0000-0000-000000000000"
  );
};
